// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/valve-spring-wire/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const valveSpringWireEN: PageEntry = {
  id: "post.ventilfederdraht",
  locale: "en",
  slug: "valve-spring-wire",
  seo: {
    title: "Glossary: Valve spring wire explained simply | Dietz GmbH",
    description: "Valve spring wire is a special wire used for the production of springs in valve mechanisms. These springs are crucial for the function of valves in various applications, from car e",
  },
  type: "post",
  h1: "Glossary: Valve spring wire explained simply",
  intro: "Valve spring wire is a special wire used for the production of springs in valve mechanisms. These springs are crucial for the function of valves in various applications, from car engines to industrial processes. The valve spring wire must fulfil special requirements in terms of strength, elasticity and corrosion resistance to ensure reliable and long-term valve spring function. The selection of the right material and precise manufacturing are crucial for the quality and performance of valve springs in technical systems.",
  blocks: [

  ],
};
